export default __webpack_public_path__ + "static/media/RM-okladki-75lat.7e704292.png";